import { render, staticRenderFns } from "./StackChart.vue?vue&type=template&id=8f3b6526&scoped=true&"
import script from "./StackChart.vue?vue&type=script&lang=js&"
export * from "./StackChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3b6526",
  null
  
)

export default component.exports